module.exports = __webpack_public_path__ + "explore/images/eoy/top-publishers/elle-2x.b1ea53d01022da0fb78a5b258f7fb04a.png";